/* Sekme 2 — dress code. Banner görseli kırpılmaz; görsel yoksa yer tutucu. */

import type { Lang, SiteContent } from "../../shared/types.js";
import { t } from "../../shared/types.js";
import { ui } from "../lib/i18n.js";

export function DressCodeTab({ content, lang }: { content: SiteContent; lang: Lang }) {
  const { dressCode } = content;

  return (
    <div style={{ paddingTop: 28 }}>
      <h2 className="eyebrow">{ui("dressTitle", lang)}</h2>
      <h1 className="display">{t(dressCode.title, lang)}</h1>

      <figure className="rise" style={{ margin: "24px 0 0" }}>
        {dressCode.image ? (
          <img
            src={"/gorseller/" + dressCode.image}
            alt={t(dressCode.imageAlt, lang)}
            loading="lazy"
            decoding="async"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "var(--radius)",
              border: "1px solid var(--line)",
            }}
          />
        ) : (
          <div
            role="img"
            aria-label={t(dressCode.imageAlt, lang)}
            style={{
              width: "100%",
              aspectRatio: "4 / 5",
              borderRadius: "var(--radius)",
              border: "1px dashed var(--line)",
              background:
                "repeating-linear-gradient(135deg, rgba(255,255,255,.035) 0 12px, rgba(255,255,255,.015) 12px 24px)",
              display: "grid",
              placeItems: "center",
              padding: 24,
              textAlign: "center",
            }}
          >
            <span
              style={{
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                fontSize: 13,
                color: "var(--text-dim)",
                lineHeight: 1.6,
              }}
            >
              dress code görseli buraya
              <br />
              (public/gorseller/ · WebP)
            </span>
          </div>
        )}
      </figure>

      <p
        className="lede rise"
        style={{ ["--i" as string]: 1, whiteSpace: "pre-line", marginTop: 22 }}
      >
        {t(dressCode.text, lang)}
      </p>
    </div>
  );
}
